var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fnetworkstatus not-visible"},[_c('f-popover',{ref:"popover",staticClass:"fnetworkstatus_window"},[_vm._v(" "+_vm._s(_vm._('fnetworkstatus.message'))+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }